module.exports = __webpack_public_path__ + "static/img/Vision.fecaa903.png";